/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 1/7/16.
 */

'use strict';

angular
.module('prism-ui.package')
.service('PartnerPackagesService',

function (
    _,
    $q,
    moment,
    ComponentInventoryResourceFactory,
    ContentResourceFactory,
    MetadataService,
    PackageResourceFactory,
    PackageUtilService,
	PartnerPackagesResourceFactory,
    UtilsService
) {

	var self = this;

	var _parentPackageObject;

	var _partnerPackages = [];
	var _seasonPartnerPackages = [];
	var _volumePartnerPackages = [];

	var _partnerComponentsMap = {};

	var _originalPartnerPackages = [];
	var _originalSeasonPartnerPackages = [];
	var _originalVolumePartnerPackages = [];

	var _originalPartnerComponentsMap = {};

	var _deliveryInstanceMap = {};
	var _originalDeliveryInstanceMap = {};

	var _selectedInstanceMap = {};
	var _selectedInstanceRevisionAccessors = {};

	/*
	 * TODO
	 * 		- default label
	 * 		- disable preview buttons
	 * 		- collection order...?
	 * 		- live clipping
	 */


	//================//
	// Getter-Setters //
	//================//

	self.parentPackageObject = function () { return _parentPackageObject; };

	self.partnerPackages = function () { return _partnerPackages; };
	self.seasonPartnerPackages = function () { return _seasonPartnerPackages; };
	self.volumePartnerPackages = function () { return _volumePartnerPackages; };

	self.partnerComponentsMap = function () { return _partnerComponentsMap; };

	self.originalPartnerPackages = function () { return _originalPartnerPackages; };
	self.originalSeasonPartnerPackages = function () { return _originalSeasonPartnerPackages; };
	self.originalVolumePartnerPackages = function () { return _originalVolumePartnerPackages; };

	self.originalPartnerComponentsMap = function () { return _originalPartnerComponentsMap; };

	self.deliveryInstanceMap = function () { return _deliveryInstanceMap; };
	self.selectedInstanceMap = function () { return _selectedInstanceMap; };
	self.selectedInstanceRevisionAccessors = function () { return _selectedInstanceRevisionAccessors; };

	self.clearData = function () {
		_partnerPackages = [];
		_seasonPartnerPackages = [];
		_volumePartnerPackages = [];

		_partnerComponentsMap = {};

		_originalPartnerPackages = [];
		_originalSeasonPartnerPackages = [];
		_originalVolumePartnerPackages = [];

		_originalPartnerComponentsMap = {};

		_deliveryInstanceMap = {};
	};

	self.clearInstanceSelections = function () {
		_parentPackageObject = undefined;

		_selectedInstanceMap = {};
		_selectedInstanceRevisionAccessors = {};
	};


	//==========//
	// Metadata //
	//==========//

	var getBasicAndAdvancedProps = function (properties) {
		var props = {basic: {}, advanced: {}};
		_.forEach(properties, function (prop, name) {
			if (prop.advanced) {
				props.advanced[name] = prop;
			} else {
				props.basic[name] = prop;
			}
		});
		return props;
	};

	var buildPartnerComponentsMap = function (partnerPackage) {
		var errorsWarnings = PackageUtilService.errorsAndWarnings()[partnerPackage.partner.name];
		var allComponents = MetadataService.buildCustomComponentMap(partnerPackage.metadata.properties, errorsWarnings);

		return getBasicAndAdvancedProps(allComponents);
	};


	//===================//
	// Supplemental Data //
	//===================//

	self.queryContentCategories = function (packageObject) {
		return ContentResourceFactory.getContentCategories({
			id: packageObject.content.id,
			categoryId: packageObject.category.id,
		}).$promise;
	};

	self.querySeasons = function (packageId) {
		return PackageResourceFactory.query({
			id: packageId,
			sub: 'seasons',
		}).$promise;
	};

	self.queryVolumes = function (packageId) {
		return PackageResourceFactory.query({
			id: packageId,
			sub: 'volumes',
		}).$promise;
	};


	//===========================================//
	// Partner Packages & Distribution Instances //
	//===========================================//

	var updateErrorsAndWarnings = function () {

		//
		// TODO - single partner package E&W update
		//

		var validationResults = [];

		if (_parentPackageObject && _parentPackageObject.validationResult) {
			var packageValidationResult = _parentPackageObject.validationResult.filter(function (result) {
				return result && result.source === _parentPackageObject.name;
			})[0];
			if (packageValidationResult) {
				validationResults.push(packageValidationResult);
			}
		}

		_.forEach(_partnerPackages, function (partnerPkg) {
			if (partnerPkg.validationResult) {
				validationResults.push(partnerPkg.validationResult);
			}
		});

		PackageUtilService.createErrorsAndWarningsMap(validationResults);
	};

	var processPartnerPackage = function (partnerPkg) {
		// build metadata components map
		_partnerComponentsMap[partnerPkg.id] = buildPartnerComponentsMap(partnerPkg);
		_originalPartnerComponentsMap[partnerPkg.id] = _.cloneDeep(_partnerComponentsMap[partnerPkg.id]);
	};

	var replacePartnerPackageInArray = function (partnerPackageArray, partnerPackage) {
		var index = _.findIndex(partnerPackageArray, {id: partnerPackage.id});
		partnerPackageArray.splice(index, 1, partnerPackage);
	};

	var amendPartnerPackageArrays = function (partnerPackage) {
		replacePartnerPackageInArray(_partnerPackages, partnerPackage);
		replacePartnerPackageInArray(_originalPartnerPackages, partnerPackage);
		if (partnerPackage.subscription.seasonSubscription) {
			replacePartnerPackageInArray(_seasonPartnerPackages, partnerPackage);
			replacePartnerPackageInArray(_originalSeasonPartnerPackages, partnerPackage);
		} else {
			replacePartnerPackageInArray(_volumePartnerPackages, partnerPackage);
			replacePartnerPackageInArray(_originalVolumePartnerPackages, partnerPackage);
		}
	};

	self.mostRecentDeliveryInstance = function (partnerPackageId) {
		// element 0 is the "Create new ..." label, so the most
		// recent instance is at element 1
		return _deliveryInstanceMap[partnerPackageId][1].id;
	};

	var createRevisionAccessor = function (partnerPackageId) {
		//
		// Creates a closure that can be used to read/write a
		// partner package instance's revision, without any data
		// identifying the partner package.
		//
		// This closure is then stored in a map keyed on partner
		// package IDs so it may be easily accessed via template.
		//

		_selectedInstanceRevisionAccessors[partnerPackageId] = function (revision) {
			var selectedInstance = _deliveryInstanceMap[partnerPackageId].filter(function (instance) {
				return instance.id === _selectedInstanceMap[partnerPackageId];
			})[0];

			if (arguments.length) {
				selectedInstance.revision = revision;
			}
			return selectedInstance.revision;
		};
	};

	var processInstanceList = function (partnerPackageId, deliveryInstances) {
		// Add dropdown-select label to each instance
		_.forEach(deliveryInstances, function (deliveryInstance) {
			var lastEditedFmt = moment(deliveryInstance.lastEdited).format('YYYYMMDD');
			deliveryInstance.label = deliveryInstance.instance + ' - Last Edited ' + lastEditedFmt;
		});

		// Sort descending by instance number (they should be
		// sorted by creation time, which will have the same
		// ordinality as the instance number)
		deliveryInstances = _.sortBy(deliveryInstances, 'instance').reverse();

		// Add "Create new instance" option to dropdown collection
		deliveryInstances.unshift({
			label: 'Create new instance',
			createNew: true,
		});

		_deliveryInstanceMap[partnerPackageId] = deliveryInstances;
		_originalDeliveryInstanceMap[partnerPackageId] = _.cloneDeep(deliveryInstances);

		createRevisionAccessor(partnerPackageId);
	};

	var queryDeliveryInstances = function (partnerPackage) {
		return PartnerPackagesResourceFactory.getDeliveryInstances({
			partnerPackageId: partnerPackage.id,
		}).$promise.then(function (deliveryInstances) {
			return {
				partnerPackage: partnerPackage,
				deliveryInstances: deliveryInstances,
			};
		});
	};

	var queryAllDeliveryInstances = function () {
		var instancePromises = {};
		_.forEach(_partnerPackages, function (partnerPackage) {
			if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
				return;
			}

			instancePromises[partnerPackage.id] = queryDeliveryInstances(partnerPackage)
				.then(function (instanceData) {
					processInstanceList(partnerPackage.id, instanceData.deliveryInstances);

					// Select most recent by default
					if (!_selectedInstanceMap[partnerPackage.id]) {
						_selectedInstanceMap[partnerPackage.id] = self.mostRecentDeliveryInstance(partnerPackage.id);
					}
					return instanceData.deliveryInstances;
				});
		});

		return $q.all(instancePromises);
	};

	self.selectPartnerPackageInstance = function (partnerPackage, instanceId) {
		var params = {
			partnerPackageId: partnerPackage.id,
			deliveryInstanceId: instanceId? instanceId: undefined,
		};

		return PartnerPackagesResourceFactory.getPartnerPackage(params).$promise
			.then(function (partnerPackage) {
				amendPartnerPackageArrays(partnerPackage);
				updateErrorsAndWarnings();		// (!!) This could be called a lot. See note at top of method.
				processPartnerPackage(partnerPackage);
				return queryDeliveryInstances(partnerPackage);
			})
			.then(function (instanceData) {
				_selectedInstanceMap[partnerPackage.id] = instanceId;
				processInstanceList(partnerPackage.id, instanceData.deliveryInstances);
			})
			.then(function () {
				return PackageUtilService.pollForPackageUpdates();
			});
	};

	self.createPartnerPackageInstance = function (partPkg) {
		return PartnerPackagesResourceFactory.createDeliveryInstance({
			partnerPackageId: partPkg.id
		}).$promise;
	};

	self.saveInstanceRevisions = function () {
		var savePromises = [];

		_.forEach(_deliveryInstanceMap, function (deliveryInstances, partnerPackageId) {
			_.forEach(deliveryInstances, function (instance, index) {
				if (UtilsService.compareBasic(instance, _originalDeliveryInstanceMap[partnerPackageId][index])) {
					savePromises.push(
						PartnerPackagesResourceFactory.updateDeliveryInstance(
							{instanceId: instance.id},
							instance
						).$promise
					);
				}
			});
		});

		if (savePromises.length > 0) {
			return $q.all(savePromises);
		} else {
			return $q.when(true);
		}
	};

	self.updatePartnerPackage = function (partnerPackage) {
		return PartnerPackagesResourceFactory.updatePartnerPackage({
			partnerPackageId: partnerPackage.id,
			deliveryInstanceId: _selectedInstanceMap[partnerPackage.id],
		}, partnerPackage).$promise;
	};

	//
	// Called after retrieving all partner packages from the main
	// PP API. That call only grabs the most recent instances;
	// this scans the selected instance map and updates any
	// partner packages with older (e.g. "not most recent")
	// selections made in the UI.
	//
	var queryOldPartnerPackageInstances = function () {
		var selectPromises = [];

		_.forEach(_partnerPackages, function (partnerPackage) {
			if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
				return;
			}

			if (_selectedInstanceMap[partnerPackage.id] !== self.mostRecentDeliveryInstance(partnerPackage.id)) {
				selectPromises.push(
					self.selectPartnerPackageInstance(
						partnerPackage,
						_selectedInstanceMap[partnerPackage.id]
					)
				);
			}
		});

		return $q.all(selectPromises);
	};

	self.queryPartnerPackages = function (packageId, parentPackageObject) {

		//
		// packageId
		// 		the ID of the package whose partner packages to
		// 		obtain
		//
		// parentPackageObject
		// 		the ID of the package whose partner package
		// 		instance selections and validation data will be
		// 		remembered - won't match the packageId when on the
		//		clipping tab; we still have to remember what the
		//		parent package was
		//

		_parentPackageObject = parentPackageObject;

		//
		// Cloning here detaches the arrays from the controller.
		// This prevents flicker when grabbing new edit data,
		// because we first grab all of the most recent instances
		// in one API call, but then have to go back and replace
		// any existing instance selections with subsequent,
		// discrete API calls.
		//
		// The controller should replace its references to these
		// arrays after calling this function.
		//

		_partnerPackages = _.cloneDeep(_partnerPackages);
		_seasonPartnerPackages = _.cloneDeep(_seasonPartnerPackages);
		_volumePartnerPackages = _.cloneDeep(_volumePartnerPackages);

		_partnerComponentsMap = _.cloneDeep(_partnerComponentsMap);
		_deliveryInstanceMap = _.cloneDeep(_deliveryInstanceMap);

		// Step 1: Get all the partner packages, specifically the
		// most recent instances of each package, in one API call.
		return PackageResourceFactory.query({
			id: packageId,
			sub: 'partnerPackages'
		}).$promise
		.then(function (partnerPackages) {
			_partnerPackages = _.sortBy(partnerPackages, function (partnerPkg) {
				return partnerPkg.partner.name.toLowerCase();
			});
			_seasonPartnerPackages = _partnerPackages.filter(function (partnerPkg) {
				return partnerPkg.subscription.seasonSubscription;
			});
			_volumePartnerPackages = _partnerPackages.filter(function (partnerPkg) {
				return !partnerPkg.subscription.seasonSubscription;
			});

			// Step 2: Get metadata property definitions before
			// processing partner packages and building components
			// map.
			return MetadataService.propertiesPromise;
		})
		.then(function () {
			// digest E&W's for all partner packages, then build
			// metadata components map
			updateErrorsAndWarnings();
			_.forEach(_partnerPackages, processPartnerPackage);

			// Step 3: Get instance lists for each partner package
			return queryAllDeliveryInstances();
		})
		.then(function () {
			_originalDeliveryInstanceMap = _.cloneDeep(_deliveryInstanceMap);

			// Step 4: Update instances for packages that have
			// older selections made in the UI
			return queryOldPartnerPackageInstances();
		})
		.then(function () {
			_originalPartnerPackages = _.cloneDeep(_partnerPackages);
			_originalSeasonPartnerPackages = _.cloneDeep(_seasonPartnerPackages);
			_originalVolumePartnerPackages = _.cloneDeep(_volumePartnerPackages);

			_originalPartnerComponentsMap = _.cloneDeep(_partnerComponentsMap);
			_originalDeliveryInstanceMap = _.cloneDeep(_deliveryInstanceMap);
		})
		.then(function () {
			return _partnerPackages;
		});
	};

	self.isPartnerPackageModified = function (partnerPackage) {
		var originalPartnerPackage = _originalPartnerPackages.filter(function (p) {
			return partnerPackage.id === p.id;
		})[0];
		var partnerComponents = _partnerComponentsMap[partnerPackage.id];
		var originalPartnerComponents = _originalPartnerComponentsMap[partnerPackage.id];

		return (
			UtilsService.compareBasic(partnerPackage, originalPartnerPackage) ||
			UtilsService.compareBasic(partnerComponents, originalPartnerComponents)
		);
	};

	self.isPartnerDataModified = function () {
		// returns true if any partner data is modified - doesn't
		// examine instance selections (but does examine instance
		// revision numbers
		return (
			UtilsService.compareBasic(_partnerPackages, _originalPartnerPackages) ||
			UtilsService.compareBasic(_partnerComponentsMap, _originalPartnerComponentsMap) ||
			UtilsService.compareBasic(_deliveryInstanceMap, _originalDeliveryInstanceMap)
		);
	};

	self.parentPackageId = function () {
		if (_parentPackageObject && _parentPackageObject.id) {
			return _parentPackageObject.id;
		} else {
			return -1;
		}
	};

	var reviseInstanceValidationResult = function (validationResults, partnerPackage) {
		var selectedInstance = _selectedInstanceMap[partnerPackage.id];
		var mostRecentInstance = self.mostRecentDeliveryInstance(partnerPackage.id);
		var instanceValidationPromise = null;

		if (selectedInstance !== mostRecentInstance) {
			var params = {
				partnerPackageId: partnerPackage.id,
				deliveryInstanceId: selectedInstance,
			};

			instanceValidationPromise = PartnerPackagesResourceFactory.getPartnerPackage(params).$promise
				.then(function (partnerPackage) {
					var foundIndex = _.findIndex(validationResults, function (validationResult) {
						return validationResult.source === partnerPackage.partner.name;
					});

					if (partnerPackage.validationResult) {
						if (foundIndex >= 0) {
							// replace the result with the instance's result
							validationResults.splice(foundIndex, 1, partnerPackage.validationResult);
						} else {
							// add the instance's result
							validationResults.push(partnerPackage.validationResult);
						}
					} else if (foundIndex >= 0) {
						// remove the result
						validationResults.splice(foundIndex, 1);
					}
				});
		}

		return instanceValidationPromise;
	};

	self.reviseInstanceValidationResults = function (packageId, validationResults) {
		var vrPromise = $q.defer();
		if (_parentPackageObject && packageId === _parentPackageObject.id) {
			var partnerPackagePromises = [];
			_.forEach(_partnerPackages, function (partnerPackage) {
				if (!partnerPackage.partner.partnerDeliveryInstanceEnabled) {
					return;
				}

				var instanceValidationPromise = reviseInstanceValidationResult(validationResults, partnerPackage);
				if (instanceValidationPromise) {
					partnerPackagePromises.push(instanceValidationPromise);
				}
			});

			$q.all(partnerPackagePromises).then(function () {
				vrPromise.resolve(validationResults);
			});
		} else {
			vrPromise.resolve();
		}

		return vrPromise.promise;
	};

	self.getSelectedInstance = function (partnerPackage) {
		var selectedInstance;
		if (partnerPackage.packageId === self.parentPackageId()) {
			var selectedInstanceId = self.selectedInstanceMap()[partnerPackage.id];
			if (selectedInstanceId) {
				selectedInstance = _deliveryInstanceMap[partnerPackage.id].filter(function (instance) {
					return instance.id === selectedInstanceId;
				})[0];
			}
		}
		return selectedInstance;
	};

	self.getPartnerPackagesForValidation = function (packageId) {
		var basePartnerPackages;

		return PackageResourceFactory.query({
			id: packageId,
			sub: 'partnerPackages',
		}).$promise
		.then(function (partnerPackages) {
			basePartnerPackages = partnerPackages;

			var instancePromises = [];
			_.forEach(partnerPackages, function (partnerPackage) {
				var selectedInstance = self.getSelectedInstance(partnerPackage);
				if (selectedInstance && selectedInstance.id !== self.mostRecentDeliveryInstance(
						partnerPackage.id)) {
					instancePromises.push(PartnerPackagesResourceFactory.getPartnerPackage({
						partnerPackageId: partnerPackage.id,
						deliveryInstanceId: selectedInstance.id,
					}).$promise);
				}
			});
			return $q.all(instancePromises);
		})
		.then(function (partnerPackageInstances) {
			var partnerPackageMap = _.keyBy(basePartnerPackages, 'id');
			var instanceObjectPromises = [];

			_.forEach(partnerPackageInstances, function (partnerPackageInstance) {
				partnerPackageMap[partnerPackageInstance.id] = partnerPackageInstance;
			});
			_.forEach(partnerPackageMap, function (partnerPackage) {
				instanceObjectPromises.push(queryDeliveryInstances(partnerPackage));
			});
			return $q.all(instanceObjectPromises);
		})
		.then(function (partnerPackageInstanceTuples) {
			_.forEach(partnerPackageInstanceTuples, function (partnerPackageInstanceTuple) {
				var deliveryInstances = _.sortBy(partnerPackageInstanceTuple.deliveryInstances, 'instance');

				partnerPackageInstanceTuple.partnerPackage.deliveryInstances = deliveryInstances;
			});
			return _.map(partnerPackageInstanceTuples, 'partnerPackage');
		});
	};

	self.revertPartnerPackages = function () {
		_partnerPackages = _.cloneDeep(_originalPartnerPackages);
		_seasonPartnerPackages = _.cloneDeep(_originalSeasonPartnerPackages);
		_volumePartnerPackages = _.cloneDeep(_originalVolumePartnerPackages);

		_partnerComponentsMap = _.cloneDeep(_originalPartnerComponentsMap);
		_deliveryInstanceMap = _.cloneDeep(_originalDeliveryInstanceMap);
	};

    self.getApplicableDeliveryItems = (partnerPackageId) => {
        return PartnerPackagesResourceFactory.getApplicableDeliveryItems({partnerPackageId: partnerPackageId}).$promise;
    };

    self.approvePartnerPackageForPreDeliveryQc = (partnerPackageId, message) => {
        return PartnerPackagesResourceFactory.approvePartnerPackageForPreDeliveryQc({partnerPackageId: partnerPackageId, message: message}).$promise;
    };

    self.rejectPartnerPackageForPreDeliveryQc = (partnerPackageId, message) => {
        return PartnerPackagesResourceFactory.rejectPartnerPackageForPreDeliveryQc({partnerPackageId: partnerPackageId, message: message}).$promise;
    };

    self.getComponentInventory = (packageId, partnerId) => {
        return ComponentInventoryResourceFactory.query({
            packageId,
            partnerId
        }).$promise;
    };

    self.updateComponentInventory = (componentInventoryObject) => {
        return ComponentInventoryResourceFactory.updateComponentInventory(
            {
                id: componentInventoryObject.id
            },
            componentInventoryObject
        ).$promise;
    };
});
